import React, { useEffect, useState } from "react";
import "./AdmOtherDetails.css";
import { useParams } from "react-router-dom";
import { ApiUrl } from "../../../ApiUrl";
import {
  validateAadhar,
  validatePhoneNumber,
  validateEmail,
} from "../../utils/validation";

const AdmOtherDetails = ({ formData, setFormData }) => {
  const { id } = useParams();
  const [errors, setErrors] = useState([]);

  useEffect(() => {
    if (!formData.emegencyContact || formData.emegencyContact.length === 0) {
      setFormData((prevData) => ({
        ...prevData,
        emegencyContact: [
          { name: "", relationship: "", Mobile_Number: "", remark: "" },
        ],
      }));
    }
  }, [formData.emegencyContact, setFormData]);

  // Fetch emergency contact details based on student ID
  // useEffect(() => {
  //   const fetchEmergencyContacts = async () => {
  //     try {
  //       const response = await fetch(
  //         `${ApiUrl.apiurl}STUDENTREGISTRATIONAPI/GetStudentDetailsBasedOnId/${id}`
  //       );
  //       const data = await response.json();

  //       // Only set emergency contacts if the field is empty
  //       if (
  //         data?.data?.emergency_contact &&
  //         (!formData.emegencyContact || formData.emegencyContact.length === 0)
  //       ) {
  //         setFormData((prevData) => ({
  //           ...prevData,
  //           emegencyContact:
  //             data.data.emergency_contact.length > 0
  //               ? data.data.emergency_contact
  //               : [
  //                 {
  //                   name: "",
  //                   relationship: "",
  //                   Mobile_Number: "",
  //                   remark: "",
  //                 },
  //               ],
  //         }));
  //       }
  //     } catch (error) {
  //       console.error("Error fetching emergency contacts:", error);
  //     }
  //   };

  //   fetchEmergencyContacts();
  // }, [id, formData.emegencyContact, setFormData]);


  useEffect(() => {
    const fetchEmergencyContacts = async () => {
      try {
        const response = await fetch(
          `${ApiUrl.apiurl}STUDENTREGISTRATIONAPI/GetStudentDetailsBasedOnId/${id}`
        );
        const data = await response.json();

        // Only set emergency contacts if the field is empty
        if (
          data?.data?.emergency_contact &&
          (!formData.emegencyContact || formData.emegencyContact.length === 0)
        ) {
          setFormData((prevData) => ({
            ...prevData,
            emegencyContact:
              data.data.emergency_contact.length > 0
                ? data.data.emergency_contact
                : [
                    {
                      name: "",
                      relationship: "",
                      Mobile_Number: "",
                      remark: "",
                    },
                  ],
          }));
        }
      } catch (error) {
        console.error("Error fetching emergency contacts:", error);
      }
    };

    if (id) {
      fetchEmergencyContacts();
    }
  }, [id, formData.emegencyContact, setFormData]);


  // Function to handle adding a new row with validation
  const handleAddRow = () => {
    // Validate required fields before adding a new row
    const incompleteContacts = formData.emegencyContact.filter(
      (contact) =>
        !contact.name || !contact.relationship || !contact.Mobile_Number
    );

    if (incompleteContacts.length > 0) {
      alert(
        "Please fill in all required fields (Name, Relationship, Phone No) for emergency contacts before adding a new one."
      );
      return; // Prevent adding a new row
    }

    // If validation passes, add a new row
    setFormData((prevData) => ({
      ...prevData,
      emegencyContact: [
        ...prevData.emegencyContact,
        { name: "", relationship: "", Mobile_Number: "", remark: "" },
      ],
    }));
  };

  // Function to handle removing a row
  const handleRemoveRow = (index) => {
    setFormData((prevData) => ({
      ...prevData,
      emegencyContact: prevData.emegencyContact.filter((_, i) => i !== index),
    }));
  };

  // Function to handle input changes in the table
  const handleInputChange = (index, field, value) => {
    const updatedContacts = [...formData.emegencyContact];

    if (field === "relationship") {
      value = value.replace(/[^a-zA-Z\s]/g, "");
    }

    updatedContacts[index][field] = value;

    // Validation for Mobile_Number field
    if (field === "Mobile_Number") {
      const updatedErrors = [...errors];

      if (!validatePhoneNumber(value)) {
        updatedErrors[index] = "Phone number must contain only numbers.";
      } else if (value.length < 10) {
        updatedErrors[index] = "Phone number must be exactly 10 digits.";
      } else {
        updatedErrors[index] = ""; // Clear error if valid
      }

      setErrors(updatedErrors); // Update error state
    }

    setFormData((prevData) => ({
      ...prevData,
      emegencyContact: updatedContacts,
    }));
  };

  return (
    <div className="container-fluid form-container">
      <div className="table-responsive">
        <table className="table">
          <thead>
            <tr>
              <th>S.No.</th>
              <th>
                Name<span className="red-text">*</span>
              </th>
              <th>
                Relationship<span className="red-text">*</span>
              </th>
              <th>
                Phone No<span className="red-text">*</span>
              </th>
              <th>Remarks</th>
              <th>Remove</th>
            </tr>
          </thead>
          <tbody>
            {formData.emegencyContact &&
              formData.emegencyContact.map((contact, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>
                    <input
                      type="text"
                      value={contact.name}
                      style={{ textTransform: "none" }}
                      onChange={(e) =>
                        handleInputChange(index, "name", e.target.value)
                      }
                      required
                    />
                  </td>
                  <td>
                    <input
                      type="text"
                      value={contact.relationship}
                      style={{ textTransform: "none" }}
                      onChange={(e) =>
                        handleInputChange(index, "relationship", e.target.value)
                      }
                      required
                    />
                  </td>
                  {/* <td>
  <input
    type="text"
    value={contact.Mobile_Number}
    onChange={(e) => handleInputChange(index, "Mobile_Number", e.target.value)}
    maxLength={10} // Restrict input to 10 characters
    required
    
  />
  {errors[index] && (
    <span style={{ color: "red", fontSize: "0.8em", marginTop: "4px", display: "block" }}>
      {errors[index]}
    </span>
  )}
</td> */}

                  <td>
                    <input
                      type="text"
                      value={contact.Mobile_Number}
                      onChange={(e) => {
                        // Restrict input to only digits (0-9)
                        const value = e.target.value.replace(/[^0-9]/g, ""); // This regex removes any non-numeric character
                        handleInputChange(index, "Mobile_Number", value);
                      }}
                      maxLength={10} // Restrict input to 10 characters
                      required
                    />
                    {errors[index] && (
                      <span
                        style={{
                          color: "red",
                          fontSize: "0.8em",
                          marginTop: "4px",
                          display: "block",
                        }}
                      >
                        {errors[index]}
                      </span>
                    )}
                  </td>

                  <td>
                    <input
                      type="text"
                      value={contact.remark}
                      style={{ textTransform: "none" }}
                      onChange={(e) =>
                        handleInputChange(index, "remark", e.target.value)
                      }
                    />
                  </td>
                  <td>
                    <button
                      className="btn btn-danger"
                      onClick={() => handleRemoveRow(index)}
                    >
                      Remove
                    </button>
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
      <div className="d-flex justify-content-end">
        <button className="btn btn-primary" onClick={handleAddRow}>
          Add New Row
        </button>
      </div>
    </div>
  );
};

export default AdmOtherDetails;
